// languages.ts
export const getAvailableLanguages = (): string[] => {
  const languages = import.meta.env.VITE_APP_AVAILABLE_LANGUAGES || '';
  return languages.split(',').map(lang => lang.trim());
};
